import {
	Component,
	Input,
	HostListener,
	ElementRef,
	OnChanges,
	Output,
	EventEmitter,
	ViewChild,
	ViewContainerRef,
} from "@angular/core";

@Component({
	selector: "app-audio",
	// tslint:disable-next-line:max-line-length
	template: `<audio
		style="width:100%;"
		*ngIf="presMode === 'high' || presMode === 'medium'"
		#audioTag
		autoplay
		controls
		controlsList="nodownload"
		src="{{ path }}"
		(onplaying)="onPlayingHandler()"
		(timeupdate)="ontimeupdate()"
	>
		Your browser doesn't support this audio element.
	</audio>`,
})
export class AudioDirective implements OnChanges {
	@Input() public path: string;
	@Input() public presMode: string;
	@Input() public audioOn: boolean;
	@Input() public pauseAudio: boolean;

	@Output() audioCompleted?: EventEmitter<any> = new EventEmitter<any>();
	@Output() audioStarted?: EventEmitter<any> = new EventEmitter<any>();
	@Output() timeUpdated?: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild("audioTag", { read: ViewContainerRef }) _audioTag;

	private audio_el;
	private startEventFired = false;

	constructor(private elementRef: ElementRef) {}

	ngOnChanges(changes) {
		console.log("change in audio path", changes);
		if (
			changes.hasOwnProperty(`pauseAudio`) &&
			changes[`pauseAudio`][`currentValue`] != undefined
		) {
			if (changes[`pauseAudio`][`currentValue`] === true) {
				this.audio_el.pause();
			} else {
				this.audio_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
			}
		}
	}

	ngAfterViewInit() {
		this.startEventFired = false;
		console.log("audio tag");
		console.log(this._audioTag);
		console.log("audio tag");
		const _owner = this;
		if (this._audioTag) {
			this.audio_el = this._audioTag.element.nativeElement;
			this.audio_el.addEventListener("ended", function () {
				_owner.startEventFired = false;
				_owner.audioCompleted.emit({ url: _owner.path });
			});
		}
	}

	ontimeupdate() {
		if (
			this._audioTag.element.nativeElement.currentTime > 0 &&
			!this.startEventFired
		) {
			this.startEventFired = true;
			this.audioStarted.emit("");
		}
		this.timeUpdated.emit(this._audioTag.element.nativeElement.currentTime);
	}
}
